module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/stavyToku@3x-89a6f8cd60818699baaae41ea8c10db6.png";